import { createElement, isValidElement, } from "react";
import { isObjectElement, isTextElement } from "./validate/index.js";
function createVariantComponentWrapper(children, displayName) {
    const Component = () => children;
    Component.displayName = displayName;
    return Component;
}
export function createVariantElement(type, node) {
    if (isTextElement(node)) {
        return createElement(type, { children: node });
    }
    if (isObjectElement(node)) {
        return createElement(type, node);
    }
    if (isValidElement(node)) {
        const ComponentWrapper = createVariantComponentWrapper(node, type.displayName);
        return createElement(ComponentWrapper);
    }
    return node;
}
